import { type IntegrationCredentialSummary } from "shared/types";
import { formatIntegrationLabel } from "utils/formatIntegrationLabel";

type SourceItem = {
  integration_credential?: IntegrationCredentialSummary | null;
  pms_id?: string | null;
};

export const getSourceLabel = (item?: SourceItem): string => {
  if (!item) return "Manually added";

  if (item.integration_credential)
    return formatIntegrationLabel(item.integration_credential) ?? "";

  if (item.pms_id) return "PMS";

  return "Manually added";
};
